import React, { useEffect, useState } from 'react';
import { Card, Button, Spinner } from 'react-bootstrap';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { authServices } from 'Utils/auth/services';
import SportWiseTable from 'Common/Tables/eventWiseTable/sportReportTable';

interface FancyPLData {
    sport_name: string;
    uplineProfitLoss: number;
    total: number;
    commission: number;
    type: number;
    sport_id: string;
    total_net_pl: string;
}

interface Payload {
    from_date: string | undefined;
    to_date: string | undefined;
}


const defaultSportOrder = [
    "Cricket",
    "Session",
    "Soccer",
    "Tennis",
    "Horse Racing",
    "Greyhound Racing",
    "Casino",
];

const SportReport: React.FC = () => {
    const [startDate, setStartDate] = useState<Date>(() => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        yesterday.setHours(0, 0, 0, 0);
        return yesterday;
    });

    const [endDate, setEndDate] = useState<Date>(() => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        yesterday.setHours(23, 59, 59, 999);
        return yesterday;
    });

    const [isLoading, setIsLoading] = useState(false);
    const [casinoBetsData, setCasinoBetsData] = useState<FancyPLData[]>([]);
    const [netPlTotal, setNetPlTotal] = useState<number>(0);


    const get = async () => {
        setIsLoading(true);
        try {
            const payload: Payload = {
                from_date: startDate.toISOString(),
                to_date: endDate.toISOString(),
            };

            const { response } = await authServices.eventWisePlReport(payload);

            if (response?.data) {
                const sortedData = [...response.data].sort((a, b) => {
                    const aIndex = defaultSportOrder.indexOf(a.sport_name);
                    const bIndex = defaultSportOrder.indexOf(b.sport_name);
                    return (aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex);
                });

                setCasinoBetsData(sortedData);
                setNetPlTotal(response.total || 0);
            } else {
                setCasinoBetsData([]);
                setNetPlTotal(0);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setCasinoBetsData([]);
            setNetPlTotal(0);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        get();
    }, []);

    const handleRowClick = (sport_id: string, sport_name: string) => {
        const from_date = startDate.toISOString();
        const to_date = endDate.toISOString();
        const url = `/eventreport/${sport_id}/${sport_name}/${from_date}/${to_date}`;
        window.open(url, "_blank");
    };

    return (
        <div className="event-pl">
            <Card className="event-pl-card mb-3">
                <Card.Header className="event-pl-header">
                    <div className="date-filter d-flex gap-2 align-items-center">
                        <Flatpickr
                            className="form-control"
                            options={{
                                enableTime: true,
                                dateFormat: "Y-m-d H:i:S",
                            }}
                            value={startDate}
                            onChange={([date]: Date[]) => setStartDate(date)}
                        />
                        <Flatpickr
                            className="form-control"
                            options={{
                                enableTime: true,
                                dateFormat: "Y-m-d H:i:S",
                            }}
                            value={endDate}
                            onChange={([date]: Date[]) => setEndDate(date)}
                        />
                        <Button
                            variant="success"
                            className="submit-btn"
                            onClick={get}
                        >
                            Filter
                        </Button>
                    </div>
                </Card.Header>
            </Card>

            <Card>
                <Card.Body>
                    {isLoading ? (
                        <div className="text-center">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    ) : (
                        <SportWiseTable
                            fancyPLData={casinoBetsData}
                            total={netPlTotal}
                            onRowClick={handleRowClick}
                        />
                    )}
                </Card.Body>
            </Card>
        </div>
    );
};

export default SportReport;
